import type { AllUserInfo } from '../types/user.types'

export const enum PossibleInfo {
	ACTIVE_PURCHASE = 'activePurchases',
	INACTIVE_PURCHASE = 'inactivePurchases',
}

export const INITIAL_ALL_USER_INFO: AllUserInfo = {
	userInfo: {
		activePurchases: [],
		inactivePurchases: [],
	},
}
